import { Box, Button, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { notEmpty, validPassword } from '../../util/Validation';
import axios from '../../util/Axios';
import { selectPasswordResetToken } from '../../store/selectors/GlobalSelector';
import { useTranslation } from 'react-i18next';

export function ChooseNewPassword() {
  const { t } = useTranslation();
  const resetPasswordToken = useSelector(selectPasswordResetToken);
  const selectedPassword = useSelector((state) => state.GlobalReducer.registrationInfo.password);

  const [password, setPassword] = useState(selectedPassword);
  const [repeatedPassword, setRepeadetPassword] = useState(selectedPassword);

  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch({ type: actions.PASSWORD_RESET_CANCELLED });
  };

  const handleChangePassword = () => {
    changePassword();
  };

  const changePassword = () => {
    const request = { resetPasswordToken, password: password };
    axios.post(`/users/changepass/withToken`, request).then((resp) => {
      dispatch({ type: actions.PASSWORD_RESET_SUCCESS });
    });
  };

  const passwordDoNotMatch = () => {
    if (repeatedPassword === '') {
      return false;
    }
    return password !== repeatedPassword;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 5 }}>
      <TextField type="password" helperText={t('password_help')} error={!validPassword(password)} value={password} onChange={(event) => setPassword(event.target.value)} label={t('enter_password')}></TextField>
      <TextField type="password" error={passwordDoNotMatch()} helperText={passwordDoNotMatch() ? t('password_mismatch') : ''} required value={repeatedPassword} onChange={(event) => setRepeadetPassword(event.target.value)} label={t('repeat_password')}></TextField>
      <Stack direction="row" sx={{ marginTop: 5 }}>
        <Button sx={{ width: '50%' }} onClick={handleCancel}>
          {t('cancel')}
        </Button>

        <Button disabled={!notEmpty(password, validPassword) || password !== repeatedPassword} sx={{ width: '50%' }} variant="contained" color="primary" onClick={handleChangePassword}>
          {t('change_password')}
        </Button>
      </Stack>
    </Box>
  );
}
